<app-apps-banner></app-apps-banner>
<section class="mt-5 freight-volume-calculator">
  <div class="container">
    <div class="row pb-80">
      <div class="col-lg-8 pe-md-4 pe-xl-5 border-right sm-border-none">

        <div class="border-bottom pb-3 d-md-none d-block">
          <!-- <p class="back-link">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </p> -->

        <a class="back-link linked" routerLink="/apps">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </a>

        <div class="d-flex">
          <img src="../assets/images/icons/freight-volume-calculator.png" class="card-img-top img-fluid app-img me-4" alt="Container Specification">
          <h2>Freight Volume Calculator</h2>
        </div>
      </div>

      <div class="d-md-flex align-items-md-center border-bottom pb-3 d-none d-md-flex">
        <img src="../assets/images/icons/freight-volume-calculator.png" class="card-img-top img-fluid app-img" alt="Container Specification">
        <div class="ms-4">
          <!-- <p class="back-link mb-0">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </p> -->
        <a class="back-link linked" routerLink="/apps">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </a>
        <h2>Freight Volume Calculator</h2>
      </div>
    </div>

    <div class="bg-gray pt-0 pb-4">
      <div class="">
        <div class="freight-vol-calc-group d-flex align-items-center">
          <img src="assets/images/apps/dimension-calculator.jpg" alt="Dimension Calculator" class="img-fluid">
          <h6 class="mb-0 text-white">Dimension Calculator</h6>
        </div>
        <form [formGroup]="dimensionCalForm" class="dimension-calculator ps-3 pe-3">
          @for (item of dimensionCalForm.get('dcFormArr')['controls']; track item; let i = $index) {
            <div formArrayName="dcFormArr">
              <div [formGroupName]="i">
                <div class="row">
                  <div class="form-group col-md-3 pe-md-0">
                    <label for="no-pieces">Number of Pieces</label>
                    <input type="text" formControlName="numberOfPieces" class="form-control cust-input" id="no-pieces" placeholder="Enter number">
                    @if (item.controls.numberOfPieces.touched && item.controls.numberOfPieces.errors) {
                      <div class="invalid-feedback invalid_1">
                        @if (item.controls.numberOfPieces.errors.required) {
                          <div>Number is required</div>
                        }
                        @if (item.controls.numberOfPieces.errors.pattern) {
                          <div>only numbers are allowed</div>
                        }
                      </div>
                    }
                  </div>
                  <div class="form-group col-md-3 pe-md-0">
                    <label for="no-pieces">Length of Piece</label>
                    <input type="text" formControlName="lengthOfPieces" class="form-control cust-input" id="length-of-pieces" placeholder="Enter length">
                    @if (item.controls.lengthOfPieces.touched && item.controls.lengthOfPieces.errors) {
                      <div class="invalid-feedback invalid_1">
                        @if (item.controls.lengthOfPieces.errors.required) {
                          <div>Length is required</div>
                        }
                        @if (item.controls.lengthOfPieces.errors.pattern) {
                          <div>only numbers are allowed</div>
                        }
                      </div>
                    }
                  </div>
                  <div class="form-group col-md-3 pe-md-0">
                    <label for="no-pieces">Width of Piece</label>
                    <input type="text" formControlName="widthPiece" class="form-control cust-input" id="width-of-piece" placeholder="Enter width">
                    @if (item.controls.widthPiece.touched && item.controls.widthPiece.errors) {
                      <div class="invalid-feedback invalid_1">
                        @if (item.controls.widthPiece.errors.required) {
                          <div>Width is required</div>
                        }
                        @if (item.controls.widthPiece.errors.pattern) {
                          <div>only numbers are allowed</div>
                        }
                      </div>
                    }
                  </div>
                  <div class="form-group col-md-3">
                    <label for="no-pieces">Height of Piece</label>
                    <input type="text" formControlName="heightPiece" (input)="onDMHeightChange(item,i)" class="form-control cust-input" id="destination-address" placeholder="Enter height">
                    @if (item.controls.heightPiece.touched && item.controls.heightPiece.errors) {
                      <div class="invalid-feedback invalid_1">
                        @if (item.controls.heightPiece.errors.required) {
                          <div>Height is required</div>
                        }
                        @if (item.controls.heightPiece.errors.pattern) {
                          <div>only numbers are allowed</div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="row pt-0 pt-md-3">
                  <div class="form-group col-md-3 pe-md-0">
                    <label for="no-pieces">Unit</label>
                    <select class="form-select cust-input" formControlName="unit" (change)="onDMHeightChange(item,i)" id="unit" name="unit">
                      <option value="" selected>Select Unit</option>
                      @for (item of units; track item) {
                        <option [value]="item.id">{{item.name}}</option>
                      }
                    </select>
                  </div>
                  <div class="form-group col-md-3 pe-md-0">
                    <label for="no-pieces">CBM</label>
                    <input type="text" formControlName="cbm1" class="form-control cust-input" id="destination-address" placeholder="Enter CBM" disabled>
                  </div>
                  <div class="form-group col-md-3 pe-md-0">
                    <label for="no-pieces">CBF</label>
                    <input type="text" formControlName="cbf1" class="form-control cust-input" id="destination-address" placeholder="Enter CBM" disabled>
                  </div>
                  <div class="form-group col-md-3 pe-md-0 pt-10" style="padding-top: 10px;">
                    <br>
                      @if (isRemoveFalg) {
                        <button type="button" (click)="removeDCForm(i)" class="btn btn-danger btn-sm">Remove</button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            <div class="">
              <button type="button" (click)="addNewDCForm()" class="btn btn-primary btn-sm mt-3">Add</button>
            </div>
            <div class="yellow-bg d-md-flex align-items-center grand-total">
              <h6 class="text-white w-100 mb-0">GRAND TOTAL </h6>
              <input [readonly]="true" type="text" formControlName="cbm" class="form-control cust-input" placeholder="Total CBM" />
              <input [readonly]="true" type="text" formControlName="cbf" class="form-control cust-input" placeholder="Total CBF" />
            </div>
          </form>
        </div>
      </div>

      <div class="bg-gray pt-0 pb-4 mt-5">
        <div class="">
          <div class="freight-vol-calc-group d-flex align-items-center">
            <img src="assets/images/apps/unit-converter.jpg" alt="Unit Converter" class="img-fluid">
            <h6 class="mb-0 text-white">Unit Converter</h6>
          </div>

          <form [formGroup]="unitConvertorForm" class="unit-convertor ps-3 pe-3">
            <div class="row mx-0">
              <div class="col-lg-3 col-md-3 px-0">
                <div class="form-group pe-md-0">
                  <p>Length</p>
                  <select class="form-select cust-input" formControlName="unitlength" (change)="onSelectUnitLength($event)" id="unit" name="unit">
                    <option value="false" value="" selected>Select Unit</option>
                    @for (item of unitLengthList; track item) {
                      <option [ngValue]="item">{{item.C_NAME}}</option>
                    }
                  </select>
                  <input type="text" formControlName="unitLengthVal" (input)="onSelectUnitLength($event)" (paste)="onValuePaste($event)" (keypress)="numberOnly($event)" class="form-control cust-input mb-4" placeholder="Enter Length">
                  @if (f.unitLengthVal.touched && f.unitLengthVal.errors) {
                    <div class="invalid-feedback">
                      @if (f.unitLengthVal.errors.required) {
                        <div>Length is required</div>
                      }
                    </div>
                  }
                  <div class="calResult">
                    @if (unitlengthLoader) {
                      <div class="loader">
                        <i class="fa fa-circle-o-notch fa-spin  fa-fw"></i>
                        <span class="sr-only">Loading...</span>
                      </div>
                    }
                    <input type="text" formControlName="unitlengthRes" class="form-control calc-result border-none" placeholder="Calculation" [readonly]="true">
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 px-0">
                <div class="form-group pe-md-0">
                  <p>Weight</p>
                  <select class="form-select cust-input" formControlName="unitWeight" (change)="onSelecteUnitWeight()" id="unit" name="unit">
                    <option value="" selected>Select Unit</option>
                    @for (item of unitWeightList; track item) {
                      <option [ngValue]="item">{{item.C_NAME}}</option>
                    }
                  </select>
                  <input type="text" formControlName="unitWeightVal" (input)="onSelecteUnitWeight()" (paste)="onValuePaste($event)" (keypress)="numberOnly($event)" class="form-control cust-input mb-4" placeholder="Enter Weight">
                  @if (f.unitWeightVal.touched && f.unitWeightVal.errors) {
                    <div class="invalid-feedback">
                      @if (f.unitWeightVal.errors.required) {
                        <div>Weight is required</div>
                      }
                    </div>
                  }
                  <div class="calResult">
                    @if (unitWeightLoader) {
                      <div class="loader">
                        <i class="fa fa-circle-o-notch fa-spin  fa-fw"></i>
                        <span class="sr-only">Loading...</span>
                      </div>
                    }
                    <input type="text" formControlName="unitWeightRes" class="form-control calc-result" placeholder="Calculation" [readonly]="true">
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 px-0">
                <div class="form-group pe-md-0">
                  <p>Volume</p>
                  <select class="form-select cust-input" formControlName="unitValume" (change)="onSelecteUnitValume()" id="unit" name="unit">
                    <option value="" selected>Select Unit</option>
                    @for (item of unitValumeList; track item) {
                      <option [ngValue]="item">{{item.C_NAME}}</option>
                    }
                  </select>
                  <input type="text" class="form-control cust-input mb-4" (input)="onSelecteUnitValume()" (paste)="onValuePaste($event)" (keypress)="numberOnly($event)" formControlName="unitValumeVal" placeholder="Enter Volume">
                  @if (f.unitValumeVal.touched && f.unitValumeVal.errors) {
                    <div class="invalid-feedback">
                      @if (f.unitValumeVal.errors.required) {
                        <div>Volume is required</div>
                      }
                    </div>
                  }
                  <div class="calResult">
                    @if (unitValumeLoader) {
                      <div class="loader">
                        <i class="fa fa-circle-o-notch fa-spin  fa-fw"></i>
                        <span class="sr-only">Loading...</span>
                      </div>
                    }
                    <input type="text" class="form-control calc-result" formControlName="unitValumeRes" placeholder="Calculation" [readonly]="true">
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 px-0">
                <div class="form-group pe-md-0">
                  <p>Temperature</p>
                  <select class="form-select cust-input" formControlName="unitTemp" (change)="onSelecteUnitTempList()" id="unit" name="unit">
                    <option value="" selected>Select Unit</option>
                    @for (item of unitTempList; track item) {
                      <option [ngValue]="item">{{item.C_NAME}}</option>
                    }
                  </select>
                  <input type="text" class="form-control cust-input mb-4" (input)="onSelecteUnitTempList()" (paste)="onValuePaste($event)" (keypress)="numberOnly($event)" formControlName="unitTempVal" placeholder="Enter Temperature">
                  @if (f.unitTempVal.touched && f.unitTempVal.errors) {
                    <div class="invalid-feedback">
                      @if (f.unitTempVal.errors.required) {
                        <div>Temperature is required</div>
                      }
                    </div>
                  }
                  <div class="calResult">
                    @if (unitTempLoader) {
                      <div class="loader">
                        <i class="fa fa-circle-o-notch fa-spin  fa-fw"></i>
                        <span class="sr-only">Loading...</span>
                      </div>
                    }
                    <input type="text" class="form-control calc-result" formControlName="unitTempRes" placeholder="Calculation" [readonly]="true">
                  </div>
                </div>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>

    <div class="col-lg-4 ps-md-4 ps-xl-5 pe-lg-0">
      <app-other-apps [menu]="'freight'"></app-other-apps>
    </div>
  </div>

</div>
</section>

<app-sat></app-sat>

<router-outlet></router-outlet>